module.exports = __webpack_public_path__ + "img/赵海涛.be97c83a.png";